import './Loader.css';
import { LoaderProps } from '@/types';
import { CircularProgress, Box } from '@mui/material';

export default function Loader({ type = 'tetris' }: { type?: LoaderProps }) {
  if (type === 'tetris') {
    return (
      <div className="loader">
        <div className="loader-inner">
          <div className="loader-block"></div>
          <div className="loader-block"></div>
          <div className="loader-block"></div>
          <div className="loader-block"></div>
          <div className="loader-block"></div>
        </div>
      </div>
    );
  }

  if (type === 'circular') {
    return (
      <Box className="loader-circular-box">
        <CircularProgress size={60} />
      </Box>
    );
  }

  return null;
}
